import { Progress } from "@/components/ui/progress";
import { STAFF_DIALOG_STEPS } from "@/constants/staff/staff-constants";

interface StaffDialogProgressProps {
  currentStep: number;
}

export function StaffDialogProgress({ currentStep }: StaffDialogProgressProps) {
  const progressPercentage =
    ((currentStep + 1) / STAFF_DIALOG_STEPS.length) * 100;

  return (
    <div className="w-full mt-4">
      <div className="flex mb-2">
        {STAFF_DIALOG_STEPS.map((step, index) => (
          <div
            key={step.id}
            className={`text-sm font-medium text-center ${
              index === currentStep
                ? "text-primary"
                : index < currentStep
                  ? "text-muted-foreground"
                  : "text-muted-foreground/50"
            }`}
            style={{ width: `${100 / STAFF_DIALOG_STEPS.length}%` }}
          >
            {step.label}
          </div>
        ))}
      </div>

      <Progress value={progressPercentage} className="h-0.5 w-full" />
    </div>
  );
}
